import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { Modal } from 'bootstrap';
import { Data2Service } from '../../common/data2.service';
import { DateService } from '../../common/date.service';
import { UuidService } from '../../common/uuid.service';
import { InfoboxService } from '../../common/infobox/infobox.service';
import { Category, Courier, Post, PostInOptions, Task } from '../post.model';

@Component({
	selector: 'app-post-in',
	templateUrl: './post-in.component.html',
	styleUrls: ['./post-in.component.css'],
})
export class PostInComponent implements OnInit {
	loader = true;
	private itemsBeforeDataLoad = 4;
	pageTitle: string;
	editable: boolean;
	lockEdit: boolean;
	post: Post = {
		id: null,
		received: null,
		due: null,
		sender: null,
		recipient: null,
		documentType: null,
		description: null,
		givenTo: null,
		createdBy: null,
		category: null,
		courier: null,
	};
	errors = {
		received: '',
		due: '',
		sender: '',
		recipient: '',
		documentType: '',
		givenTo: '',
		createdBy: '',
	};
	users: Array<any> = [];
	senders: Array<any> = [];
	companies: Array<any> = [];
	documentTypes: Array<any> = [];
	categories: Category[] = [];
	couriers: Courier[] = [];
	showDocumentTypes = false;
	showSenders = false;
	task: Task;

	constructor(
		private readonly api: Data2Service,
		private readonly date: DateService,
		private readonly uuid: UuidService,
		private readonly infobox: InfoboxService,
		private readonly route: ActivatedRoute,
		private readonly router: Router,
	) {}

	ngOnInit(): void {
		if (this.route.snapshot.params['id']) {
			// We are in edit mode
			this.editable = true;
			this.lockEdit = true;
			this.post.id = this.route.snapshot.params['id'];
		} else {
			// We are in add mode
			this.editable = false;
			this.pageTitle = 'Korespondencja';
			this.post.received = this.date.now().date;
			// new Date().toISOString().slice(0, 10);
			this.post.due = this.date.daysAdd(+7);
		}
		this.loader = true;
		this.api.get('/users/?status=1', (result, error) => {
			this.users = result.data;
			this.loadData();
			this.setCurrentUserAsCreatedBy();
		});
		this.api.get('/company/', (result, error) => {
			this.companies = result.data;
			this.loadData();
		});
		this.api.get('/postDocumentTypes/', (result, error) => {
			this.documentTypes = result.data;
			this.loadData();
		});
		this.api.get('/postSenders/', (result, error) => {
			this.senders = result.data;
			this.loadData();
		});
		this.api.get('/postInOptions/', (result: PostInOptions, error) => {
			this.categories = result.data?.category ?? [];
			this.couriers = result.data?.courier ?? [];
			this.loadData();
		});
		if (this.post.id) {
			this.api.command('/tasks/', { cmd: 'find', type: 'postIn', id: this.post.id }, (result, error) => {
				this.task = result.data;
			});
		}
	}

	setCurrentUserAsCreatedBy(): void {
		const user = this.users.find((pos) => pos.id === localStorage.getItem('userId'));

		this.post.createdBy = user?.id;
	}

	editToggle(): void {
		this.lockEdit = !this.lockEdit;
	}

	submit(): void {
		let hasErrors = false;
		for (const key in this.errors) {
			if (!this.post[key]) {
				this.errors[key] = true;
				hasErrors = true;
				continue;
			}
			this.errors[key] = false;
		}
		if (hasErrors) {
			this.loader = false;
			return;
		}
		this.lockEdit = true;
		if (this.editable) {
			this.api.put('/postIn/' + this.post.id + '/', this.post, (result, error) => {
				this.afterSend(result, error);
			});
		} else {
			this.post.id = this.uuid.generate();
			this.api.post('/postIn/', this.post, (result, error) => {
				this.afterSend(result, error);
			});
		}
	}

	private afterSend(result, error): void {
		if (error) {
			return;
		}
		if (!this.post.due) {
			this.router.navigate(['post']);
			return;
		}
		const sender = this.senders.find((obj) => obj.id == this.post.sender);
		const documentType = this.documentTypes.find((obj) => obj.id == this.post.documentType);
		let content = 'Nadawca: ' + sender?.name + '\n';
		content += 'Typ dokumentu: ' + documentType.name + '\n';
		content += 'Uwagi: ' + this.post.description + '\n';
		const task = {
			id: this.uuid.generate(),
			objType: 'postIn',
			objId: this.post.id,
			type: 'POST',
			deadline: this.post.due + ' 23:59:59',
			content: content,
			owners: [this.post.givenTo],
		};
		this.api.post('/tasks/', task, (result, error) => {
			if (error) {
				return;
			}
			this.router.navigate(['postIn']);
		});
	}

	sendersSearch(name: string, item) {
		name = name.toLowerCase();
		return item.name.toLowerCase().indexOf(name) > -1 || item.name.toLowerCase() === name;
	}

	sendersOpen() {
		new Modal(document.getElementById('sendersModal')).show();
	}

	sendersClose() {
		const modal = Modal.getInstance(document.getElementById('sendersModal'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	private loadData(): void {
		if (!this.editable) {
			return;
		}
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.api.get('/postIn/' + this.post.id + '/', (result, error) => {
			this.post = result.data;
			this.pageTitle = 'Edycja';
			this.loader = false;
		});
	}
}
